// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
//import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'fa4',
    //     values: {}
  },
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#009688',
        accent: '#CDDC39',
        secondary: '#CDDC39',
        info: '#64B5F6',
        warning: '#FFAB40',
        error: '#FF5252',
        success: '#9CCC65',
        navy: '#455a64', //'#65767f',
        text: '#607D8B',
        darktheme: '#121212',
        grey: '#9e9e9e',
      }
    }
  }
}

export default new Vuetify(opts)
